import { useModalContext } from '../../contexts/modal-context'

export const useModalProps = <T>(modalId: string): T => {
  const { getModalProps } = useModalContext()

  const modalProps = getModalProps(modalId)

  return modalProps as T
}
